import React from "react";

class StringDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data && typeof this.props.data !== 'undefined'){
      return (
        <div dangerouslySetInnerHTML={{ __html: this.props.data }} className={`${this.renderAlignment()} StringDataType`}></div>
      );
    } else {
      return (
        I18n.t('none')
      )
    }
  }

  renderAlignment() {
    if (this.props.header && this.props.header.text_align === "left") {
      return "text-left";
    } else if (this.props.header && this.props.header.text_align === "center") {
      return "text-center";
    } else if (this.props.header && this.props.header.text_align === "right") {
      return "text-right";
    } else {
      ("");
    }
  }
};

export default StringDataType